// utils/format.js - CORREGIDO PARA FECHAS UTC

/**
 * ⭐ ARREGLO CRÍTICO: Django envía fechas en UTC, debemos convertir a local
 */

/**
 * Parsea fecha string a objeto Date local
 * Backend envía: "2025-01-15T19:00:00Z" (UTC)
 * Debemos mostrar: 15/01/2025 en zona horaria local
 */
export function parseUTCDate(dateString) {
  if (!dateString) return null;

  if (dateString.includes("T")) return new Date(dateString);

  const [y, m, d] = dateString.split("-");
  return new Date(Number(y), Number(m) - 1, Number(d));
}


/**
 * Formatea fecha completa (día nombre, fecha completa)
 * Ejemplo: "martes, 15 de enero de 2025"
 */
export function formatDate(dateString, locale = 'es-AR') {
  const date = parseUTCDate(dateString);
  if (!date) return '-';
  
  return date.toLocaleDateString(locale, {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
}

/**
 * Formatea fecha corta
 * Ejemplo: "15/01/2025"
 */
export function formatShortDate(dateString, locale = 'es-AR') {
  const date = parseUTCDate(dateString);
  if (!date) return '-';
  
  return date.toLocaleDateString(locale);
}

/**
 * Formatea solo la hora
 * Ejemplo: "19:00"
 */
export function formatTime(dateString, locale = 'es-AR') {
  const date = parseUTCDate(dateString);
  if (!date) return '-';
  
  return date.toLocaleTimeString(locale, {
    hour: '2-digit',
    minute: '2-digit'
  });
}

/**
 * Formatea fecha y hora juntas
 * Ejemplo: "15/01/2025 19:00"
 */
export function formatDateTime(dateString, locale = 'es-AR') {
  const date = parseUTCDate(dateString);
  if (!date) return '-';
  
  return date.toLocaleString(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

/**
 * Formatea moneda
 * Ejemplo: "$15.000,00"
 */
export function formatCurrency(amount, currency = 'ARS', locale = 'es-AR') {
  if (amount === null || amount === undefined) return '-';
  
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency
  }).format(amount);
}

/**
 * Formatea teléfono argentino
 * Ejemplo: "+54 9 381 1234567"
 */
export function formatPhone(phone) {
  if (!phone) return '-';
  
  const cleaned = phone.replace(/[\s()-]/g, '');
  
  if (cleaned.startsWith('+549')) {
    const number = cleaned.slice(4);
    return `+54 9 ${number.slice(0, 3)} ${number.slice(3)}`;
  }
  
  return phone;
}

/**
 * Trunca texto largo
 */
export function truncate(text, maxLength = 50) {
  if (!text || text.length <= maxLength) return text;
  return text.slice(0, maxLength) + '...';
}

/**
 * Capitaliza primera letra
 */
export function capitalize(text) {
  if (!text) return '';
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}

/**
 * Pluraliza según cantidad
 */
export function pluralize(count, singular, plural) {
  return count === 1 ? singular : plural;
}

/**
 * ⭐ NUEVO: Formatea fecha relativa (hace X días, en X días)
 */
export function formatRelativeDate(dateString) {
  const date = parseUTCDate(dateString);
  if (!date) return '-';
  
  const now = new Date();
  const diffMs = date - now;
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  
  if (diffDays === 0) return 'Hoy';
  if (diffDays === 1) return 'Mañana';
  if (diffDays === -1) return 'Ayer';
  if (diffDays > 0) return `En ${diffDays} días`;
  if (diffDays < 0) return `Hace ${Math.abs(diffDays)} días`;
  
  return formatShortDate(dateString);
}

/**
 * ⭐ NUEVO: Convierte fecha local a formato ISO para enviar al backend
 * Ejemplo: "2025-01-15" → "2025-01-15T00:00:00Z"
 */
export function toISODate(dateString) {
  if (!dateString) return null;
  
  // Si ya es ISO, retornar
  if (dateString.includes('T')) return dateString;
  
  // Si es formato "YYYY-MM-DD", convertir a ISO
  const date = new Date(dateString + 'T00:00:00');
  return date.toISOString();
}

/**
 * ⭐ NUEVO: Convierte fecha local a formato "YYYY-MM-DD" para inputs
 */
export function toInputDate(dateString) {
  const date = parseUTCDate(dateString);
  if (!date) return '';
  
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  
  return `${year}-${month}-${day}`;
}